'use strict';

const carouselResources = window.carouselResources || {};

// Custom Arrows for slick carousels
const prevLabel = carouselResources.prev || 'Previous';
const nextLabel = carouselResources.next || 'Next';
const prevArrow = `<button class='slick-prev slick-arrow' type='button' aria-label='${prevLabel}'><span class='sr-only'>${prevLabel}</span></button>`;
const nextArrow = `<button class='slick-next slick-arrow' type='button' aria-label='${nextLabel}'><span class='sr-only'>${nextLabel}</span></button>`;
const customPaging = (_slider, i) => {
    let slideLabel = carouselResources.slideLabel || 'Carousel slide';
    if (slideLabel.indexOf('{0}') !== -1) {
        slideLabel = slideLabel.replace('{0}', i + 1);
    } else {
        slideLabel = slideLabel + ' ' + (i + 1);
    }
    return `<button type='button' aria-label='${slideLabel}'></button>`;
};

/**
 * Reusable slick carousel configurations
 * @example - $('.product-carousel').slick(slickConfigs.pdp)
 */

module.exports = {
    hero: {
        autoplay: true,
        autoplaySpeed: 5000,
        easing: 'swing',
        infinite: true,
        speed: 800,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    promoDrawerCarousel: {
        infinite: true,
        dots: false,
        arrows: false,
        mobileFirst: true,
        variableWidth: true,
        useTransform: false,
        waitForAnimate: false,
        easing: 'swing',
        speed: 125,
        swipeToSlide: true,
        touchThreshold: 100,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    slidesToShow: 5,
                    prevArrow: prevArrow,
                    nextArrow: nextArrow
                }
            }
        ]
    },

    pdp: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: 'unslick'
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    lazyLoad: 'ondemand'
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    addedModal: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    suggestions: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    recommendedAlternatives: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    suggestionsTopPage: {
        infinite: true,
        speed: 400,
        dots: false,
        arrows: true,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ],
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    standard: {
        infinite: true,
        speed: 400,
        dots: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    footerBanner: {
        infinite: true,
        speed: 300,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ],
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    zoomMobile: {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        touchMove: false,
        infinite: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    tileImageCarousel: {
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        mobileFirst: true,
        dots: true,
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    fade: true,
                    speed: 0,
                    dots: false
                }
            }
        ],
        customPaging: customPaging
    },

    fyl: {
        slidesToShow: 2,
        slidesToScroll: 2,
        swipe: true,
        mobileFirst: true,
        dots: true,
        arrows: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    fylModal: {
        slidesToShow: 2,
        slidesToScroll: 2,
        swipe: true,
        mobileFirst: true,
        dots: true,
        arrows: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    },

    fylSingle: {
        slidesToShow: 2,
        slidesToScroll: 1,
        swipe: false,
        mobileFirst: true,
        dots: false,
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
            }
        ]
    },

    fylModalSingle: {
        slidesToShow: 2,
        slidesToScroll: 1,
        swipe: false,
        mobileFirst: true,
        dots: false,
        arrows: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    },

    fylModalHyp: {
        slidesToShow: 2,
        slidesToScroll: 2,
        swipe: true,
        mobileFirst: true,
        dots: true,
        arrows: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ],
        customPaging: customPaging,
        prevArrow: prevArrow,
        nextArrow: nextArrow
    }
};
